import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { BehaviorSubject } from 'rxjs';
import { GenCheckoutSingleConsignmentComponent } from '../../../features/checkout/checkout-single-consignment/checkout-single-consignment.component';
import { I18nModule } from '@spartacus/core';
import { GenCartType } from 'src/app/generac/enums/cart-type.enum';
import { GenShippingGroup, GenDeliveryDateGroup, GenManufactureGroup, GenSingleConsignmentInfo } from 'src/app/generac/models/cart.model';
import { GenCartSharedModule } from '../../../features/cart/cart-shared/cart-shared.module';
import { GenCheckoutScheduleReplenishmentOrderComponent } from 'src/app/generac/features/checkout/checkout-schedule-replenishment-order/checkout-schedule-replenishment-order.component';

@Component({
  selector: 'gen-checkout-delivery-groups',
  templateUrl: './checkout-delivery-groups.component.html',
  imports: [
    CommonModule,
    MatExpansionModule,
    I18nModule,
    GenCheckoutScheduleReplenishmentOrderComponent,
    GenCheckoutSingleConsignmentComponent,
    GenCartSharedModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenCheckoutDeliveryGroupsComponent implements OnInit {
  private updateDataSubject$$ = new BehaviorSubject<string | null>(null);

  @Input() shippingGroup: GenShippingGroup;
  @Input() cartCode: string;
  @Input() purchaseOrderNumber: string;
  @Input() isServicePartsEnabled: boolean;
  @Input() isOrderReview: boolean;
  desiredShipmentDateAvailable: boolean = JSON.parse(localStorage.getItem('desiredShipmentDateAvailable'));
  panelOpenState: boolean[] = [];
  updateDataTrigger$ = this.updateDataSubject$$.asObservable();
  isSpStep: boolean;
  isSubsStep: boolean;

  getSingleConsignmentInfo(manufactureGroupId: string): void {
    this.updateDataSubject$$.next(manufactureGroupId);
  }

  ngOnInit() {
    this.isSpStep = this.shippingGroup?.cartTypes[0] == GenCartType.SERVICE_PARTS;
    this.isSubsStep = this.shippingGroup?.cartTypes[0] == GenCartType.SUBSCRIPTION;
  }

  isManufactureGroup(group: GenDeliveryDateGroup | GenManufactureGroup): group is GenManufactureGroup {
    return (group as GenManufactureGroup).manufactureGroupID !== undefined;
  }

  getManufactureGroupID(group: GenDeliveryDateGroup | GenManufactureGroup): string | undefined {
    return this.isManufactureGroup(group) ? group.manufactureGroupID : undefined;
  }

  getDeliveryGroupTitle(group: GenDeliveryDateGroup | GenManufactureGroup): string | undefined {
    return this.isManufactureGroup(group) ? group.manufactureGroupIndex || group.manufactureGroupID : group?.deliveryDateGroupIndex;
  }

  getDeliveryGroupSingleConsigmentInfo(group: GenDeliveryDateGroup | GenManufactureGroup): GenSingleConsignmentInfo | undefined {
    return this.isManufactureGroup(group) ? group.singleConsignmentInfo : undefined;
  }

  getGroupDeliveryDate(group: GenDeliveryDateGroup | GenManufactureGroup): string | undefined {
    return !this.isManufactureGroup(group) ?
      (new Date(group.groupDeliveryDate) >= new Date() ? group.groupDeliveryDate : undefined) : undefined;
  }
}
